import type { NotificationListResponseNotificationsItemBasicInfo } from './notificationListResponseNotificationsItemBasicInfo';
import type { NotificationListResponseNotificationsItemData } from './notificationListResponseNotificationsItemData';
import type { NotificationListResponseNotificationsItemSource } from './notificationListResponseNotificationsItemSource';
import type { NotificationListResponseNotificationsItemStatus } from './notificationListResponseNotificationsItemStatus';
import type { NotificationListResponseNotificationsItemTarget } from './notificationListResponseNotificationsItemTarget';

/**
 * 알림 응답 데이터
 */
export type NotificationListResponseNotificationsItem = {
  basicInfo?: NotificationListResponseNotificationsItemBasicInfo;
  /** 알림 추가 데이터 (유형에 따라 다름) */
  data?: NotificationListResponseNotificationsItemData;
  /** 알림 소스 정보 */
  source?: NotificationListResponseNotificationsItemSource;
  /** 알림 상태 정보 */
  status?: NotificationListResponseNotificationsItemStatus;
  /** 알림 대상 정보 */
  target?: NotificationListResponseNotificationsItemTarget;
};
